// extracted by mini-css-extract-plugin
module.exports = {"modal":"FileViewOther_modal__3wqcF","title":"FileViewOther_title__3eGgo"};